import React from 'react'
import {Link} from 'react-router-dom'
import './orders.css'
import Login from '../login/Login';


//muestra una orden anonima
const OrdersAnony = ({id,status,fecha,items,logue,noTitular}) => {

    return (
        <section className="section-anony section-xl bg-default">
            <div className="container">
                <h2>Orden N° {id}</h2>
                <div className="pieTablaOrder">
                    <p className="estado">Fecha de Compra: {fecha(items.date)}</p>
                    <p className="estado">Estado: <span className="status2">{status}</span></p>
                </div>
                {noTitular == true ? <p className="men-user">No es el titular de la orden!</p> :
                !logue && <><p className="men-user">Si es el TITULAR y quiere ver la orden completa Logueese</p>
                <Login/></> }
                <p className="men-user">Por razones de seguridad las Ordenes que no fueron realizadas con una cuenta de "Gmail" no podran ver el detalle completo,
                    les pedimos que se comuniquen con nosotros desde la seccion <Link to={'/contacto'}>Contacto</Link></p>   
            </div>    
        </section>
    )

    
}
export default OrdersAnony;